/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationServiceAccountTarget extends models.AllocationTarget {
    constructor() {
        super();
        this.setDiscriminator("AllocationServiceAccountTarget");
    }

    getFixupPrototypeFunction() { return AllocationServiceAccountTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationServiceAccountTarget>): AllocationServiceAccountTarget {
        let obj = Object.assign(new AllocationServiceAccountTarget(), model);
        AllocationServiceAccountTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationServiceAccountTarget>): AllocationServiceAccountTarget {
        if (!model) return null;
        return AllocationServiceAccountTarget.newInstance(<AllocationServiceAccountTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationServiceAccountTarget) {
        if (!obj) return;

        models.AllocationServiceAccountTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationServiceAccountTarget): boolean {
        if (models.AllocationTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AllocationServiceAccountTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
